import { useDispatch } from "react-redux";

import { FileArrowUpRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const ContactFormAskQuestionActivity = ({ activity, onReadChange }) => {
  const dispatch = useDispatch();

  const isPlace = useTheme()?.name === "place-theme";

  const viewReportUrl = activity.data?.marketReportUrl || activity.data?.reportUrl;

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={FileArrowUpRegularV6}>
            Submitted Form
          </CategoryContainer>
        }
        personName={`${activity.data?.subjectFirstName} ${activity.data?.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField label="Form Name" data="Market Report - Asked a Question" />
        {activity.data?.questionSubject && (
          <DataField label="Subject" data={activity.data?.questionSubject} />
        )}
        {activity.data?.question && <DataField label="Message" data={activity.data?.question} />}
        <ActivityBtns
          callHandlr={() => {
            if (activity?.personUuid) {
              dispatch(
                setCallParams({ leadUuids: [activity.personUuid], callSource: "Contact Form Ask Activity" }),
              );
            }
          }}
          reportHandlr={
            viewReportUrl
              ? () => {
                  window.open(viewReportUrl, "_blank");
                }
              : null
          }
        />
      </div>
    </ActivityContainer>
  );
};

export default ContactFormAskQuestionActivity;

ContactFormAskQuestionActivity.propTypes = {
  ...activityCommonPropTypes,
};

ContactFormAskQuestionActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
